export default function noop(): void {
  // do nothing
}